import {
  Account,
  AccountListDataTransferObject,
  AccountType,
} from '@reward-platform/ancillaries-schemas/accounts'
import { nextApiClient } from './clients/nextApiClient'

export async function getMyAccounts(): Promise<AccountListDataTransferObject> {
  const { data } = await nextApiClient.get<AccountListDataTransferObject>(`/user/accounts`)

  return data
}

export async function getAccount(accountType: AccountType): Promise<Account> {
  const { data } = await nextApiClient.get<Account>(`/user/accounts`, {
    params: {
      accountType,
    },
  })

  return data
}
